import globalSettings from "./globalSettings";

// Enable with #tickaroo_debug=true (or data-tik4-debug="true" on the script tag).
export function tik4DebugLog(id: string, message: string, ...args: unknown[]) {
  if (globalSettings.debug) {
    console.debug(`[tik4 debug] ${id} ${message}`, ...args);
  }
}

// Each custom element instance carries a unique `tik4DebugId` (see AbstractLiveblogElement).
// Events are dispatched from deep inside the widget's React tree, so walk up to the nearest
// element that carries an id to attribute the event to its element instance.
export function debugIdForElement(el: Element | null): string {
  let node: Element | null = el;
  while (node) {
    const id = (node as unknown as { tik4DebugId?: string }).tik4DebugId;
    if (id) {
      return id;
    }
    node = node.parentElement;
  }
  return "?";
}
